// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
//import cource1 from "assets/images/cource1.jpg";
//import cource2 from "assets/images/2tankDive.jpg";
import BarracudaReef from "assets/images/BarracudaReef.jpg";
import GorgonianGarden from "assets/images/GorgonianGarden.jpg";
import SerendibReef from "assets/images/SerendibReef.jpg";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { CardContent, Typography } from "@mui/material";
import FormosaReef from "assets/images/FormosaReef.jpg";
function Wrecksite() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid item xs={12} lg={6}>
          <MKTypography variant="h3" mt={3} mb={0}>
            Reef Dives...
          </MKTypography>
          <MKTypography variant="body1" mt={4} mb={0}>
            Sri Lanka&apos;s west coast offers vibrant coral reefs teeming with marine life, making
            it a prime destination for divers of all levels. From the bustling city of Colombo to
            the serene beaches of Galle and Bentota, the region boasts diverse underwater
            ecosystems.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Barracuda Reef
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={-8}>
              Barracuda Reef is a vibrant underwater ecosystem situated just off the coast of Mount
              Lavinia, approximately 20 km south of Colombo. This reef is celebrated for its rich
              marine biodiversity, making it a premier destination for divers of all levels.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 8 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={BarracudaReef}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Barracuda Reef
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Gorgonian Garden Reef
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={-8}>
              Gorgonian Garden Reef, located off the East Coast of Sri Lanka near Trincomalee, is
              renowned for its stunning displays of sea fans (gorgonians) that create a vibrant,
              colorful underwater landscape. The site ranges in depth from 8–20 meters, making it
              suitable for both beginner and advanced divers. The reef is densely populated with a
              variety of soft corals, anemones, and sponges. The vertical structures of gorgonians
              provide shelter and habitat for countless reef fish, including clownfish, anthias,
              damselfish, and parrotfish.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={GorgonianGarden}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Gorgonian Garden Reef
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Formosa Reef – At a Glance
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              Situated just offshore from Colombo, Formosa Reef is a long, ridge-like sandstone and
              limestone formation ideal for beginner divers and training dives. The site, only about
              14 meters deep, is known for its dense coverage of hard and soft corals, abundant
              marine life, and excellent macro diving opportunities.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={FormosaReef}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Formosa Reef
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Serendib Reef
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Serendib Reef, located just off the coast of Colombo, is one of the most scenic
              and accessible dive sites in Sri Lanka. Sitting at an average depth of 12–18 meters,
              it is perfectly suited for divers of all levels, from beginners to experienced
              enthusiasts. The reef is made up of limestone ridges and rocky outcrops, heavily
              encrusted with colorful hard and soft corals, sponges, and sea fans. These structures
              create natural shelters and feeding grounds for an incredible variety of marine
              species. Divers can expect to encounter schools of snappers, fusiliers, parrotfish,
              and angelfish, as well as moray eels, lionfish, and the occasional stingray gliding
              across the sandy bottom.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={SerendibReef}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Serendib Reef
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Wrecksite;
